import { useScheduleEditorCreateItemMutation } from '@graphql/generated';
import { useCallback } from 'react';
import { ScheduleEditorData } from '../types';
import { ScheduleFormDisplay } from './form/ScheduleFormDisplay';
import React from 'react';
import { EMPTY_FORM_DATA, ScheduleEditorProps } from '../ScheduleEditor';
import { formatDateAsISO8601TZ, useGetEventTimezone } from './form/hooks/useGetEventTimezone';

export const AddScheduleItem = (props: ScheduleEditorProps & { mode: 'add' }) => {
  const { eventId, onSuccess, onError, onCancel, refetch } = props;
  const [addItem] = useScheduleEditorCreateItemMutation();
  const timezone = useGetEventTimezone();

  const handleSubmit = useCallback(
    async (data: ScheduleEditorData) => {
      const results = await addItem({
        variables: {
          payload: {
            eventId,
            startTimeISO8601TZ: formatDateAsISO8601TZ(data.startTime, data.timezone),
            endTimeISO8601TZ: formatDateAsISO8601TZ(data.endTime, data.timezone),
            name: data.name,
            description: data.description,
            isPublic: true,
            virtualEventLink: data.virtualEventUrl,
            dressCode: data.dressCode,
          },
        },
        refetchQueries: refetch,
      });

      if (results.data?.createEventScheduleItem) {
        onSuccess(results.data.createEventScheduleItem);
      } else {
        onError?.(results.errors);
      }
    },
    [addItem, eventId, onError, onSuccess, refetch],
  );

  return (
    <ScheduleFormDisplay
      data={{ ...EMPTY_FORM_DATA, timezone: timezone ?? '' }}
      onSubmit={handleSubmit}
      onCancel={() => {
        onCancel?.();
      }}
    />
  );
};
